import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RequestType } from "../models/RequestType";
import { ThirdParty } from "../models/ThirdParty";
import { StorageService } from "../services/Storage";

interface RequestState {
  value: {
    data: RequestType;
    isDefaultBank: boolean;
  };
}

const initialState: RequestState = {
  value: {
    data: {
      bankreader_id: "",
      document_id: "",
      bank_code: "",
      consent: "",
      tags: {
        key: "",
        value: "",
      },
      third_party: ThirdParty.TINK,
      third_party_bank: "",
      from_date: "",
      to_date: "",
      third_party_link: "",
    },
    isDefaultBank: false,
  },
};

export const requestSlice = createSlice({
  name: "request",
  initialState,
  reducers: {
    saveRequest: (state, action: PayloadAction<RequestType>) => {
      state.value.data = action.payload;
      StorageService.setBankreaderStore(state.value.data);
    },
    clearRequest: (state) => {
      state.value = initialState.value;
    },
    defaultBankMode: (state, action: PayloadAction<boolean>) => {
      state.value.isDefaultBank = action.payload;
    },
  },
});

export const { saveRequest, clearRequest, defaultBankMode } =
  requestSlice.actions;

export default requestSlice.reducer;
